import React, {Component} from 'react';
import CardFlippable from "../common/CardFlippable";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import JunkSizeMailService from '../services/JunkSizeMailService';
import Loader from 'react-loader-spinner';

class Junk extends Component {
    constructor(props) {
        super(props);

        this.localState = this.props.localState;

        this.JunkSizeMailService = new JunkSizeMailService();

        this.handleSelectJunk = this.handleSelectJunk.bind(this);
        this.togglePhotoModal = this.togglePhotoModal.bind(this);
        this.handleInputFileClick = this.handleInputFileClick.bind(this);
        this.handleSelectedFileNames = this.handleSelectedFileNames.bind(this);
        this.submitFormData = this.submitFormData.bind(this);
        this.handleFilesUpload = this.handleFilesUpload.bind(this);
        this.changeVariation = this.changeVariation.bind(this);

        this.state = {
            photoModal: false,
            junkModal: false,
            fileNames: [],
            filesForUpload: [],
            first_name: '',
            last_name: '',
            email: '',
            filesError: false,
            filesErrorMessage: '',
            mailSuccess: false,
            mailSuccessMessage: '',
            mailError: false,
            mailErrorMessage: '',
            errorResponse: null,
            loading: false,
            disabled: false,
            variation: this.props.variation,
            sizes: this.props.sizes.filter(size => size.variation.type == this.props.variation)
        };

        // this.props.variation == 'man_and_van'
        //     ? ga('set', 'page', '/wizard/man-and-van/step-1/junk-select')
        //     : ga('set', 'page', '/wizard/skip/step-1/size-select')
        //
        // ga('send', 'pageview');
    }

    componentDidUpdate(oldProps) {
        const newProps = this.props;
        if (oldProps.variation !== newProps.variation) {
            this.setState({
                    variation: newProps.variation
                }, () => this.setState({
                    sizes: this.props.sizes.filter(size => size.variation.type == this.props.variation)
                })
            )
        }
    }

    changeVariation() {
        this.props.changeVariation();
    }

    togglePhotoModal() {
        this.setState({
            first_name: '',
            last_name: '',
            email: '',
            fileNames: [],
            errorResponse: null,
            photoModal: !this.state.photoModal
        }, () => {
            this.inputFile.value = null
        });
    }

    handleSelectJunk(size) {
        this.localState.size = size;
        this.props.setValidity(true);
        this.props.globalStateChange(this.localState);
        this.props.updatePrice();

        if (this.props.variation == 'skip') {
            this.props.toggleVariationModal();
        } else {
            this.props.nextStep(size);
        }
    }

    handleSelectedFileNames() {
        let files = [];

        this.setState({
            filesError: false,
            filesErrorMessage: '',
            filesForUpload: []
        }, () => {
            if (this.inputFile.files.length > 3) {
                return this.setState({
                    filesError: true,
                    filesErrorMessage: 'You cannot upload more than 3 images'
                })
            }

            for (let i = 0; i < this.inputFile.files.length; i++) {
                files = [...files, `${this.inputFile.files[i].name} (${Math.round(this.inputFile.files[i].size / 1000)}kb)`];
            }
            this.setState({
                fileNames: files,
                filesForUpload: Array.from(this.inputFile.files)
            });
        });
    }

    handleInputChange(e) {
        e.preventDefault();
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    submitFormData() {
        const formData = new FormData();

        formData.append('first_name', this.state.first_name);
        formData.append('last_name', this.state.last_name);
        formData.append('email', this.state.email);
        this.state.filesForUpload.map((file, i) => {
            formData.append(`images[${i}]`, file);
        });

        this.setState({
            errorResponse: null,
            loading: true
        }, () => {
            this.JunkSizeMailService.sendJunkSizeEmail(formData)
                .then(res => {
                    if (res.status == 200) {
                        this.setState({
                            loading: false,
                            disabled: true,
                            mailSuccess: true,
                            mailSuccessMessage: res.data.message,
                        }, () => {
                            sessionStorage.clear();
                            setTimeout(function () {
                                window.location.href = '/mail-success'
                            }, 2000)
                        });
                    } else {
                        this.setState({
                            loading: false,
                            errorResponse: 'Unknown error occurred, please contact support'
                        })
                    }
                }, err => console.log(err))
                .catch(err => {
                    this.setState({
                        loading: false,
                        errorResponse: err.response.data.errors
                    })
                })
        })
    }

    handleInputFileClick() {
        this.inputFile.click();
    }

    handleFilesUpload(filesUpload) {
        let files = Array.from(filesUpload);
        this.setState({
            filesForUpload: files
        });
    }

    render() {
        return (
            <section id="sizes">

                <div className="container pb-5">
                    {/*<div className="row">*/}
                    {/*<div className="col-12 text-right">*/}
                    {/*{this.state.variation == 'skip' ? 'Skip' : 'Man and van'} <button className='btn btn-sm btn btn-outline-amber' onClick={this.changeVariation}>change</button>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    <div className="row pb-3 justify-content-center">
                        <h2 className="wizard-heading pt-sm-0 pt-5">Choose a collection size</h2>
                    </div>
                    <div className="row justify-content-center pb-3 text-center"
                         style={{paddingLeft: '15px', paddingRight: '15px'}}>
                        <p>Not sure about the collection size you need? Send us a <span className='prohibited-items'
                                                                                        onClick={this.togglePhotoModal}><u>photo</u>.</span>
                        </p>
                    </div>
                    {this.state.variation == 'skip' &&
                    <div className="redirect-to-man-and-van container">
                        <div className="redirect-to-man-and-van_wrap">
                            <h2>Why not use our Man & Van and <b>SAVE OVER 40%</b>?</h2>
                            <form action="/postcode" method="POST">
                                <input
                                    type="hidden"
                                    name='postcode'
                                    value={this.props.postcode}/>
                                <input type="hidden" name="page" value="man-and-van"/>
                                <button type="submit"
                                        className="btn btn-round py-3 btn-cw redirect-to-man-and-van_button">MAN &amp; VAN
                                </button>
                            </form>
                        </div>
                    </div>
                    }
                    <div className="row">
                        {this.state.sizes.map((size) => {
                            return (
                                <CardFlippable
                                    key={size.id}
                                    size={size}
                                    localState={this.props.localState}
                                    openModal={this.togglePhotoModal}
                                    handleSelectJunk={() => this.handleSelectJunk(size)}
                                />
                            )
                        })}
                    </div>
                    <div className="row justify-content-center my-5">
                        <div className="col-md-10">
                            <div className="alert alert-dark">
                                <p style={{marginBottom: '0'}}>All prices quoted are in GBP and include VAT at the
                                    current rate.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal isOpen={this.state.photoModal} toggle={this.togglePhotoModal} className={'modal-lg'}>
                    <ModalHeader toggle={this.togglePhotoModal}>Let us help</ModalHeader>
                    <ModalBody>
                        <div className="row justify-content-center py-1">
                            <div className="col-md-10 text-center">
                                <img src='/assets/img/photo.svg' alt="size" width='200'/>
                            </div>
                        </div>
                        <div className="row justify-content-center pt-2">
                            <div className="col-md-10">
                                <p>Send us up to 3 photos of the waste you need collecting and we'll be delighted to
                                    recommend a suitable collection size. <br/>
                                    We aim to respond within 2 hours (Mon - Fri, 09:00 - 17:00 excluding bank holidays.)
                                </p>
                            </div>
                        </div>
                        {this.state.mailSuccess &&
                        <div className="row justify-content-center p-3">
                            <div className="col-md-10 justify-content-center alert alert-success">
                                <p className='mb-0'>{this.state.mailSuccessMessage}</p>
                            </div>
                        </div>
                        }
                        {this.state.mailError &&
                        <div className="row justify-content-center pt-3">
                            <div className="col-md-10 justify-content-center alert alert-success">
                                <p className='mb-0'>{this.state.mailErrorMessage}</p>
                            </div>
                        </div>
                        }
                        <input type="file" name='images' multiple={true} hidden={true} ref={(section) => {
                            this.inputFile = section;
                        }} onChange={this.handleSelectedFileNames}/>
                        <div className="row justify-content-center text-center pt-3">
                            <div className="col-md-3 col-sm-12 col" onClick={this.handleInputFileClick}>
                                <div className='upload-modal'
                                     style={{border: '1px solid grey', padding: '10px', borderRadius: '7px'}}>
                                    <div><i className='fa fa-plus-square-o fa-2x'> </i></div>
                                    <p style={{marginBottom: '0'}}>add images</p>
                                </div>
                            </div>
                        </div>
                        {this.state.filesError &&
                        <div className="row justify-content-center text-center mt-3">
                            <div className="col-md-10 justify-content-center alert alert-danger">
                                <p>{this.state.filesErrorMessage}</p>
                            </div>
                        </div>
                        }
                        {this.state.fileNames.length > 0 &&
                        <div className="row justify-content-center text-center mt-3 px-3">
                            <div className="col-md-10 justify-content-center alert alert-dark mb-0">
                                {this.state.fileNames.map((file, index) => {
                                    return (
                                        <p className='file-names' key={index + 1}>{index + 1}. {file}</p>
                                    )
                                })}
                            </div>
                            {(this.state.errorResponse && (this.state.errorResponse["images.0"] || this.state.errorResponse["images.1"] || this.state.errorResponse["images.2"])) &&
                            <small className='text-danger pt-1'>Uploaded files need to be images.</small>
                            }
                        </div>
                        }

                        {(this.state.errorResponse && this.state.errorResponse.images) &&
                        <div className='row text-center justify-content-center pt-1'>
                            <small className='text-danger'>{this.state.errorResponse.images[0]}</small>
                        </div>
                        }
                        <div className="row justify-content-center pt-3">
                            <div className="col-md-10 form-group">
                                <label>First Name:</label>
                                <input type="text" name='first_name' className="form-control"
                                       placeholder='First name...' onChange={(e) => this.handleInputChange(e)}/>
                                {(this.state.errorResponse && this.state.errorResponse.first_name) &&
                                <div>
                                    <small className='text-danger'>{this.state.errorResponse.email[0]}</small>
                                </div>
                                }
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-10 form-group">
                                <label>Last Name:</label>
                                <input type="text" name='last_name' className="form-control" placeholder='Last name...'
                                       onChange={(e) => this.handleInputChange(e)}/>
                                {(this.state.errorResponse && this.state.errorResponse.last_name) &&
                                <div>
                                    <small className='text-danger'>{this.state.errorResponse.last_name[0]}</small>
                                </div>
                                }
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-10 form-group">
                                <label>Email:</label>
                                <input type="text" name='email' className="form-control" placeholder='Your email...'
                                       onChange={(e) => this.handleInputChange(e)}/>
                                {(this.state.errorResponse && this.state.errorResponse.email) &&
                                <div>
                                    <small className='text-danger'>{this.state.errorResponse.email[0]}</small>
                                </div>
                                }
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-10 form-group text-right">
                                <button className='btn btn-round py-3 btn-cw btn-yellow'
                                        onClick={this.submitFormData}
                                        disabled={(this.state.first_name == '' || this.state.last_name == '' || this.state.email == '' || !this.state.fileNames) || this.state.disabled}>
                                    <div className='d-flex flex-row justify-content-center'>
                                        {this.state.loading &&
                                        <div style={{
                                            display: 'inline-block',
                                            paddingRight: '5px',
                                        }}>
                                            <Loader type="Oval" color="#fff" height={15} width={15}/>
                                        </div>
                                        }
                                        <div>Submit</div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>


                {/*<Modal isOpen={this.state.modal} fade={false} toggle={this.toggle} className={this.props.className}>*/}
                {/*<ModalHeader toggle={this.toggle}>Modal title</ModalHeader>*/}
                {/*<ModalBody>*/}
                {/*Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.*/}
                {/*</ModalBody>*/}
                {/*<ModalFooter>*/}
                {/*<Button color="primary" onClick={this.toggle}>Do Something</Button>{' '}*/}
                {/*<Button color="secondary" onClick={this.toggle}>Cancel</Button>*/}
                {/*</ModalFooter>*/}
                {/*</Modal>*/}
            </section>
        );
    }
}


export default Junk;

